// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchProduct_wrapper__foYjH","inner":"SearchProduct_inner__+UMyc","link-a":"SearchProduct_link-a__R49jy","wrap_item":"SearchProduct_wrap_item__XEr+w"};